import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { numberFormatter } from 'components/shared/DataGrid/utils/valueFormatters/numberFormatter';

import { GridColDef } from '@mui/x-data-grid-pro';

import { useGetOptions } from './useGetOptions';

export const useGetColumnDefs = (): GridColDef[] => {
  const options = useGetOptions();
  const { t } = useTranslation('common', { keyPrefix: 'holidayHours' });

  return useMemo(() => {
    return [
      {
        field: 'pYear',
        headerName: t('grid.pYear'),
        type: 'number',
        hideable: false,
        valueFormatter: ({ value }) => value, // avoid the built-in number formatter
        flex: 1,
        headerAlign: 'left',
        align: 'left',
        minWidth: 100
      },
      {
        field: 'pPeriod',
        headerName: t('grid.pPeriod'),
        type: 'number',
        flex: 1,
        headerAlign: 'left',
        align: 'left',
        minWidth: 100
      },
      {
        field: 'periodTypeSvc',
        headerName: t('grid.periodTypeSvc'),
        type: 'singleSelect',
        valueOptions: options,
        valueFormatter: (params) => {
          const { value: fieldValue } = params;
          const option = options?.find(
            (options) => options.value === fieldValue
          );
          return option?.label;
        },
        flex: 1,
        minWidth: 100
      },
      {
        field: 'socialSecurityDays',
        headerName: t('grid.socialSecurityDays'),
        type: 'number',
        valueFormatter: numberFormatter,
        flex: 1,
        headerAlign: 'left',
        align: 'left',
        minWidth: 100
      },
      {
        field: 'holidayHours',
        headerName: t('grid.holidayHours'),
        type: 'number',
        valueFormatter: numberFormatter,
        flex: 1,
        headerAlign: 'left',
        align: 'left',
        minWidth: 100
      }
    ] as GridColDef[];
  }, [options]);
};
